import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { LatestNews, LatestNewsProps } from './LatestNews';
const defaultQueryClient = new QueryClient();

const LatesNewsGraphQL = ({ title, tag, imgFallback }: LatestNewsProps) => {
  return (
    <QueryClientProvider client={defaultQueryClient}>
      <LatestNews title={title} tag={tag} imgFallback={imgFallback} />
    </QueryClientProvider>
  );
};

export default LatesNewsGraphQL;
